import { Dropdown } from '@/components/atoms'
import { PageContainer } from '@/components/organisms'
import { ActivitiesSelector } from '@/containers/ClubPlus/CreateTier/phases/Setup/ActivitiesSelector'
import { useFormContext, Controller } from "react-hook-form"
import { useQuery } from '@tanstack/react-query'
import { getTierOptions, TIER_QUERY_KEY } from '@/services/ClubPlus/TierService'
import {useIntl} from 'react-intl'

export const Setup = () => {
  const { formatMessage } = useIntl()
  const { control, setValue } = useFormContext();

  const {
    data: tierOptionsData,
    isLoading,
    error,
  } = useQuery({
    queryKey: [TIER_QUERY_KEY.TIER_OPTIONS],
    queryFn: getTierOptions,
  });

  const tierOptions = tierOptionsData?.tierNames || [];
  const activities = tierOptionsData?.activities || [];

  const dropdownOptions = tierOptions.length > 0
    ? tierOptions.map(option => ({
        id: option.id,
        displayText: option.name,
      }))
    : [];

  return (
    <section className="mb-80 mt-10">
      <PageContainer>
        {error && <div className="text-red-500 mb-4">Failed to load tier options</div>}
        <Controller
          name={'name'}
          control={control}
          render={({ field }) => (
            <Dropdown
              label="Tier Name*"
              placeholder={formatMessage({ id: 'CLUB_PLUS.TIER_CREATE_NAME_PLACEHOLDER' })}
              isJsonWrap={false}
              isLoading={isLoading}
              childList={dropdownOptions}
              updateValue={(value) => {
                const selectedTier = value[0];
                if (selectedTier) {
                  field.onChange(selectedTier.displayText);
                  setValue('tierId', selectedTier.id);
                }
              }}
            />
          )} />
        <div className="my-5 w-full border border-gray-700" />
        <ActivitiesSelector activities={activities} />
      </PageContainer>
    </section>
  )
}
